<template>
  <Qr />
</template>

<script>
import Qr from "../components/namya/qr_signin_new_template.vue";

export default {
  name: "Homes",

  components: {
    Qr,
  },
};
</script>
